import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeProvider'
import { useEffect } from 'react'

import ImpersonateRedirect from './pages/ImpersonateRedirect'
import AccountSettings from './pages/Admin/AccountSettings'
import OHRequestForm from './components/OHRequestForm.js'
import OhDashboard from './pages/Admin/OH/Dashboard'
import OHRequestPage from './components/OHRequestPage.js'
import PersistLogin from './components/PersistLogin'
import ForgotPassword from './pages/ForgotPassword'
import CreatePassword from './pages/CreatePassword'
import RequireAuth from './components/RequireAuth'
import ResetPassword from './pages/ResetPassword'
import AccountSelect from './pages/AccountSelect'
import CheckLogin from './components/CheckLogin'
import Dashboard from './pages/Admin/Dashboard'
import AuthLayout from './layouts/AuthLayout'
import OhLayout from './layouts/OhLayout'
import Layout from './components/Layout'
import Missing from './pages/Missing'
import TwoFa from './pages/TwoFactor'
import Login from './pages/Login'

import Clarity from '@microsoft/clarity'

function App() {
  const projectId = 'ogftd8bkpx'
  Clarity.init(projectId)

  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem('impersonating_expire')
      if (expiry) {
        const expiryTime = new Date(expiry).getTime()
        if (Date.now() >= expiryTime) {
          console.info(
            'Impersonation expired, removing items from localStorage'
          )
          localStorage.removeItem('impersonating_expire')
          localStorage.removeItem('impersonating')
          window.location.reload()
        }
      }
    }, 1000 * 60)

    return () => clearInterval(interval)
  }, [])

  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public Routes */}
          <Route element={<PersistLogin />}>
            {/* Routes for logged-in users */}
            <Route element={<RequireAuth />}>
              <Route element={<AuthLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="account-select" element={<AccountSelect />} />
                <Route
                  path="/users/:id/account-settings"
                  element={<AccountSettings />}
                />
              </Route>
              <Route element={<OhLayout />}>
                <Route path="oh/dashboard" element={<OhDashboard />} />
                <Route path="oh/oha-request" element={<OHRequestPage />} />
              </Route>
            </Route>

            {/* Routes for logged-out users */}
            <Route element={<CheckLogin />}>
              <Route element={<AuthLayout />}>
                <Route path="/" element={<Login />} />
                <Route path="login" element={<Navigate to="/" replace />} />
                <Route path="2fa" element={<TwoFa />} />
                <Route path="password/forgot" element={<ForgotPassword />} />
                <Route path="password/reset" element={<ResetPassword />} />
                <Route
                  path="password/create/:token"
                  element={<CreatePassword />}
                />
              </Route>
            </Route>
            {/* Catch All */}
            <Route path="impersonate" element={<ImpersonateRedirect />} />
            <Route path="*" element={<Missing />} />
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>
  )
}

export default App
